import MoneyDisplay from '../../../Common/MoneyDisplay';
import { Table } from 'antd';


const IncomeVsExpenseTable = ({ data, loading }) => {

      const tableCols = [
        {
            title: 'Datum',
            dataIndex: 'dt_str',
            key: 'dt_str',
        },
        {
            title: 'Odhodek',
            dataIndex: 'expense',
            key: 'expense',
            render: x => <MoneyDisplay type={'EXPENSE'} val={x} />
        },
        {
            title: 'Prihodek',
            dataIndex: 'income',
            key: 'income',
            render: x => <MoneyDisplay type={'INCOME'} val={x} />
        },
        {
            title: 'Δ Neto razlika',
            dataIndex: 'difference',
            key: 'difference',
            render: x => <MoneyDisplay type={x > 0 ? 'INCOME' : 'EXPENSE'} val={x} />
        },
    ];

    return (
        <Table loading={loading} dataSource={data} columns={tableCols} size="small" pagination={false} />
    )
};

export default IncomeVsExpenseTable;
